import React, { useRef } from 'react';
import _ from 'lodash';
import { useAppContext, ACTIONS } from '@components/Contexts/AppContext';
import ResponsiveRenderer from '@src/components/SiteRenderer/ResponsiveRenderer';
import ClassicRenderer from '@src/components/SiteRenderer/ClassicRenderer';
import { getViewerNewPageId } from '@src/utils/frameHelpers';

import * as Sentry from '@sentry/browser';

const SiteRenderer = () => {
  const {
    dispatch,
    state: { isSiteResponsive },
  } = useAppContext();

  const ready = useRef<boolean>(false);

  function siteReady(previewEl: React.MutableRefObject<HTMLIFrameElement>) {
    ready.current = true;
    dispatch({
      type: ACTIONS.SET_LOADING,
      payload: false,
    });
    dispatch({
      type: ACTIONS.SET_VIEWER_ELEMENT,
      payload: {
        element: previewEl.current,
      },
    });
    const dropDownMenuExsits =
      previewEl.current.contentDocument!.querySelector('wix-dropdown-menu');
    if (dropDownMenuExsits) {
      dispatch({
        type: ACTIONS.SET_DROPDOWN_MENU_EXISTS,
        payload: { dropdownMenuExists: true },
      });
    }
    getViewerNewPageId(
      previewEl.current.contentDocument!,
      (newPageId: string) => {
        dispatch({
          type: ACTIONS.SET_CURRENT_PAGE_ID,
          payload: newPageId,
        });
      },
    );
  }

  async function handleFrameLoaded(
    previewEl: React.MutableRefObject<HTMLIFrameElement>,
  ) {
    try {
      previewEl.current.contentDocument!.addEventListener(
        'feedback-csr-ready',
        () => {
          siteReady(previewEl);
        },
        false,
      );
      _.delay(() => {
        if (!ready.current) {
          siteReady(previewEl);
        }
      }, 3000);
    } catch (e) {
      Sentry.captureException(e);
      dispatch({
        type: ACTIONS.SET_ERROR,
        payload: {
          showError: true,
          errorMsgLocalKey: 'get_feedback_error',
        },
      });
    }
  }

  return isSiteResponsive ? (
    <ResponsiveRenderer handleFrameLoaded={handleFrameLoaded} />
  ) : (
    <ClassicRenderer handleFrameLoaded={handleFrameLoaded} />
  );
};

export default SiteRenderer;
